import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';

const LoginModal = ({ visible, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Assuming api endpoint based on previous context
      // In real scenario, replace with actual API call
      // For now, simulating a login request or using axios if endpoint known
      
      const apiUrl = process.env.REACT_APP_LINYUAN_API_BASE || '';
      const response = await api.post(`/users/login`, values); 
      
      if (response.data && response.code === 200) {
        const { token, user } = response.data;
        login({ ...user, token });
        message.success('登录成功');
        onCancel();
        form.resetFields();
      } else {
        message.error(response.data?.message || '登录失败');
      }
    } catch (error) {
      console.error('Login error:', error);
      message.error('登录请求失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="用户登录"
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      width={360}
    >
      <Form
        name="login_form"
        className="login-form"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        form={form}
        size="large"
      >
        <Form.Item
          name="username"
          rules={[{ required: true, message: '请输入用户名!' }]}
        >
          <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="用户名" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: '请输入密码!' }]}
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="密码"
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button" loading={loading} block>
            登录
          </Button>
          <div style={{ marginTop: 10, textAlign: 'center' }}>
            还没有账号？ <a onClick={() => {
              onCancel();
              navigate('/register');
            }}>立即注册</a>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default LoginModal;
